/* angular:styles/component:css;39cc3f8f0326c0667bf7eb873f44755317705c3c19babe2af5cf5a5009cdb7e5;/opt/atlassian/pipelines/agent/build/src/hgm-setup/src/module/components/core/hgm-select.ts */
.main {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin: var(--margin);
}
.main.disabled {
  opacity: 0.5;
}
.label {
  color: var(--ion-text-color);
  flex-grow: 1;
  text-align: var(--label-text-align, end);
}
.label.disabled {
  opacity: 0.8;
}
.icon {
  color: var(--ion-text-color);
  height: 19px;
  min-width: 19px;
  width: 19px;
  opacity: 0.33;
  position: relative;
}
.icon.disabled {
  visibility: hidden;
}
.icon-inner {
  left: 5px;
  top: 50%;
  margin-top: -3px;
  position: absolute;
  width: 0px;
  height: 0px;
  pointer-events: none;
  border-top: 5px solid;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
.cover {
  left: 0px;
  top: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  background: transparent;
  outline: none;
}
.disabled .cover {
  cursor: initial;
}
/*# sourceMappingURL=hgm-select.css.map */
